import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-mediaroom-registry-form',
  templateUrl: './mediaroom-registry-form.component.html',
  styleUrls: ['./mediaroom-registry-form.component.css'],
})
export class MediaRoomRegistryFormComponent {
  url: string = 'mediaRoomRegistries';
  id!: string;
  form!: FormGroup;

  contentTypes = ['pack', 'asset', 'block'];
  packTypes = [
    'city_pack',
    'service_pack',
    'industry_pack',
    'blog_pack',
    'ads_copy_pack',
    'social_pack',
    'faq_pack',
    'trust_pack',
  ];
  statuses = [
    'draft',
    'review',
    'approved',
    'published',
    'refresh_due',
    'archived',
  ];
  verticals = ['courier', 'task_runner'];
  consumerTargets = ['seo', 'ads', 'social'];
  geoScopeTypes = ['city', 'metro', 'region', 'national'];

  resumenCards = [
    {
      label: '',
      value: '',
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '',
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/marketing/mediaroomRegistry',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });

    this.form = this.fb.group({
      content_id: [''],
      title: ['', [Validators.required]],
      content_type: ['', [Validators.required]],
      pack_type: ['', [Validators.required]],
      status: ['draft', [Validators.required]],
      version: ['1.0', [Validators.required]],
      consumer_targets: [[], [Validators.required]],
      vertical: ['', [Validators.required]],
      geo_scope_type: [null],
      geo_scope_value: [null],
      service_scope: [null],
      industry_scope: [null],
      owner_primary: ['', [Validators.required]],
      approved_by: [null],
      approved_at: [null],
      last_refresh_at: [null],
      refresh_due_at: [null, [Validators.required]],
      refresh_cycle_days: [60],
      published_url: [null],
      change_log_summary: [''],
      request_source: ['manual'],
      request_type: ['editorial_planning'],
      goal: ['Crear pack base para cobertura local'],
      priority: ['medium'],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('response', response);
      if (!response.consumer_targets) {
        response.consumer_targets = [];
      }

      if (response.refresh_due_at) {
        response.refresh_due_at = new Date(response.refresh_due_at)
          .toISOString()
          .split('T')[0];
      }
      if (response.approved_at) {
        response.approved_at = new Date(response.approved_at)
          .toISOString()
          .split('T')[0];
      }
      if (response.last_refresh_at) {
        response.last_refresh_at = new Date(response.last_refresh_at)
          .toISOString()
          .split('T')[0];
      }

      this.form.patchValue(response);
    });
  }

  createData(): void {
    this.dataService
      .postData(`${this.url}/add`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('marketing/mediaroom/registry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.router.navigateByUrl('marketing/mediaroomRegistry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  approveContent(): void {
    const approved_by = prompt('Ingrese el nombre del aprobador:', 'Admin');
    if (!approved_by) return;

    this.dataService
      .putData(`${this.url}/${this.id}/approve`, {
        approved_by,
        change_log_summary: this.form.get('change_log_summary')?.value,
      })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateStatus(nextStatus: string): void {
    this.dataService
      .putData(`${this.url}/${this.id}/status`, {
        nextStatus,
        change_log_summary: this.form.get('change_log_summary')?.value,
      })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  submitReview(): void {
    this.dataService
      .putData(`${this.url}/${this.id}/submit-review`, {
        change_log_summary: this.form.get('change_log_summary')?.value,
      })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  publishContent(): void {
    const published_url = this.form.get('published_url')?.value;
    if (!published_url) {
      this.messageService.add(
        'Published URL is required to publish',
        'secondary',
      );
      return;
    }

    this.dataService
      .putData(`${this.url}/${this.id}/publish`, {
        published_url,
        change_log_summary: this.form.get('change_log_summary')?.value,
      })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  archiveContent(): void {
    this.dataService
      .putData(`${this.url}/${this.id}/archive`, {
        change_log_summary: this.form.get('change_log_summary')?.value,
      })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }
}
